import { FSModels } from '@finagraph/financial-statement-editor';

import {
    WorkbookRevisionStatus,
    PortalTextFinancialStatements,
} from '../../../Models/Api/strongbox.financialportal';

export function GetStatementTypeTitle(financialStatementType: FSModels.FinancialStatementType, financialStatementsText?: PortalTextFinancialStatements, capitalize?: boolean): string {
    let result = 'financial statement';

    if (!financialStatementsText) {
        return '';
    }

    switch (financialStatementType) {
        case FSModels.FinancialStatementType.BalanceSheet:
            result = !!capitalize ? financialStatementsText.fsTypeBalanceSheet : financialStatementsText.fsTypeBalanceSheet.toLowerCase();
            break;
        case FSModels.FinancialStatementType.IncomeStatement:
            result = !!capitalize ? financialStatementsText.fsTypeIncomeStatement : financialStatementsText.fsTypeIncomeStatement.toLowerCase();
            break;
        case FSModels.FinancialStatementType.CashFlowStatement:
            result = !!capitalize ? financialStatementsText.fsTypeCashflowStatement : financialStatementsText.fsTypeCashflowStatement.toLowerCase();
            break;
    }

    return result;
}

export function GetTrackingStatusText(status: WorkbookRevisionStatus, financialStatementsText?: PortalTextFinancialStatements): string {
    if (status.outcome === 'Success') {
        return financialStatementsText?.regenStatusCompleted || '';
    } else if (status.outcome === 'Pending') {
        return financialStatementsText?.regenStatusGenerating || '';
    }
    return status.outcome;
}

export function LineItemTypeToDescription(type: FSModels.FinancialStatementLineItemType, financialStatementsText?: PortalTextFinancialStatements): string {
    switch (type) {
        case FSModels.FinancialStatementLineItemType.SectionHeader:
            return financialStatementsText?.lineItemTypeSectionHeader || '';
        case FSModels.FinancialStatementLineItemType.SectionFooter:
            return financialStatementsText?.lineItemTypeSectionFooters || '';
        case FSModels.FinancialStatementLineItemType.DetailAccount:
            return financialStatementsText?.lineItemTypeDetailAccounts || '';
    }
    return '';
}

export function MonetaryStyleToDescription(style: FSModels.PredefinedMonetaryNumberStyle, financialStatementsText?: PortalTextFinancialStatements): string {
    switch (style) {
        case FSModels.PredefinedMonetaryNumberStyle.Thousands:
            return financialStatementsText?.monetaryStyleThousands || '';
        case FSModels.PredefinedMonetaryNumberStyle.ActualsDisplayedAsWholeNumber:
            return financialStatementsText?.monetaryStyleActualsWithoutDecimals || '';
        case FSModels.PredefinedMonetaryNumberStyle.Actuals:
            return financialStatementsText?.monetaryStyleActuals || '';
    }
    return '';
}